// report-common
import { getReportActions } from '../../../../report-common';
//////////////////////////////////////////////////

const {
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  setTableTitleFilter,
  updateReportRequest,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
} = getReportActions();

export {
  // report
  setReports,
  setUsedReport,
  setListLoading,
  setFilterProps,
  setInitialState,
  setReportPending,
  setTableTitleSort,
  getItemListRequest,
  getItemListSuccess,
  createReportRequest,
  setTableTitleFilter,
  updateReportRequest,
  setIgnorePromptStatus,
  resetListAndPagination,
  exportReportDataRequest,
  changeDefaultReportRequest,
  getAvailableReportsRequest,
  // report
};
